import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

function Footer() {
  const location = useLocation();
  const currentPath = location.pathname;
  return (
    <footer className="footer">
      <div className="footerContainer">
        <NavLink to="/mentoring" activeClassName="active" className={currentPath =="mentoring" ?"decorated-link active":"decorated-link"}>
          Home 
        </NavLink>
        <NavLink to="/chat" activeClassName="active" className={currentPath =="chat" ?"decorated-link active":"decorated-link"}>
          Chat
        </NavLink>
        <NavLink to="/repository" activeClassName="active" className={currentPath =="chat" ?"decorated-link active":"decorated-link"}>
          Repository
        </NavLink>
        <NavLink to="/mentoringProfile" activeClassName="active" className={currentPath =="chat" ?"decorated-link active":"decorated-link"}>
          Profile
        </NavLink>
      </div>
    </footer>
  );
}

export default Footer;
